export default __webpack_public_path__ + "static/media/Forest-Layer-2.5dc239c1.png";